import classes from './OrgChart.module.scss';

const OrgChartIdentity = props => {
	return (
		<div className={classes['org--identity']}>
			<div>
				<h4>{props.name}</h4>
			</div>
			<div>
				<h6>{props.title}</h6>
			</div>
			<div>
				<h6>{props.email}</h6>
			</div>
		</div>
	);
};

export default OrgChartIdentity;
